"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.config = void 0;
var _utils = require("../../../../utils");
/**
 * @private
*/
const color = delta => {
  if (delta < 1) {
    return '#f5f5f5';
  }
  if (delta < 5) {
    return '#dddddd';
  }
  if (delta < 10) {
    return '#bbbbbb';
  }
  if (delta < 15) {
    return '#888888';
  }
  return '#545454';
};
/**
 * @private
*/
const config = exports.config = {
  data: {
    request: {
      endpoint: 'lightning'
    },
    properties: {
      id: 'id',
      timestamp: 'ob.timestamp'
    }
  },
  style: {
    marker: data => {
      const ts = (0, _utils.get)(data, 'ob.timestamp');
      if (!ts) {
        return null;
      }
      const delta = (new Date().getTime() - ts * 1000) / (1000 * 60);
      return {
        className: 'marker-record',
        svg: {
          shape: {
            type: 'circle',
            fill: {
              color: color(delta)
            },
            stroke: {
              color: '#ffffff',
              width: 2
            }
          }
        },
        size: [14, 14]
      };
    }
  },
  animation: {
    enabled: true
  }
};
var _default = exports.default = config;